var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIconOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pensionskassen",
    stroke: "#000",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L\\xF6schaktion",
    transform: "translate(-142.000000, -633.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "report_problem-24px",
    transform: "translate(142.000000, 633.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.275,17.5 L17.7166667,17.5 C18.3583333,17.5 18.7583333,16.8083333 18.4416667,16.25 L10.7166667,2.91666667 C10.3916667,2.35833333 9.59166667,2.35833333 9.275,2.91666667 L1.55,16.25 C1.23333333,16.8083333 1.63333333,17.5 2.275,17.5 Z M10.8333333,15 L9.16666667,15 L9.16666667,13.3333333 L10.8333333,13.3333333 L10.8333333,15 Z M10,11.6666667 C9.54166667,11.6666667 9.16666667,11.2916667 9.16666667,10.8333333 L9.16666667,8.16666667 C9.16666667,7.70833333 9.54166667,7.33333333 10,7.33333333 C10.4583333,7.33333333 10.8333333,7.70833333 10.8333333,8.16666667 L10.8333333,10.8333333 C10.8333333,11.2916667 10.4583333,11.6666667 10,11.6666667 Z",
    id: "Shape",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconOutlined);
export default __webpack_public_path__ + "static/media/Warning_Icon_Outlined.d9099ac43fe4f0f45deb2ea5b7654021.svg";
export { ForwardRef as ReactComponent };